import { FruitMachine } from './logic';

import 'normalize.css/normalize.css';
import './assets/styles/main.css';


const fruitMachine = new FruitMachine();

fruitMachine.start();